export enum Language {
  EN_US = 'eng',
  TH_TH = 'tha',
  FR_CA = 'fr-CA',
}

export interface Translation {
  language: Language;
  text: string;
}

export class TranslatedText {
  text: string;
  translations: Translation[];

  constructor(text = '', lang = 'eng') {
    this.text = text;
    this.translations = [
      {
        language: this.formatLanguage(lang),
        text: text,
      },
    ];
  }

  formatLanguage(lang: string): Language {
    switch (lang) {
      case 'en-US':
        return Language.EN_US;
      case 'th-TH':
        return Language.TH_TH;
      case 'fr-CA':
        return Language.FR_CA;
      default:
        return Language.EN_US;
    }
  }

  addTranslation(lang: string, text: string, isDefault = false) {
    this.text = isDefault ? text : this.text;
    this.translations = [
      ...this.translations.filter(
        translation => translation.language !== this.formatLanguage(lang),
      ),
      {
        language: this.formatLanguage(lang),
        text,
      },
    ];
  }
}
